import React from 'react'
import Header5 from '../../Globle/Header5'
import Smallnav from '../Mainhomefive/Smallnav'
import Banner from '../Mainhomefive/Banner'
import Collection from '../Mainhomefive/Collection'
import Claint from '../Mainhomefive/Claint'
import Jewellery from '../Mainhomefive/Jewellery'
import Deals from '../Mainhomefive/Deals'
import Advertise from '../Mainhomefive/Advertise'
import New from '../Mainhomefive/New'
import Subscribe from '../Mainhomefive/Subscribe'
import Prodect from '../Mainhomefive/Prodect'
import Footer5 from '../../Globle/Footer5'

const Main = () => {
    return (
        <>
            <Header5 />
            <Smallnav />
            <Banner />
            <Collection />
            <Claint />
            <Jewellery />
            <Deals />
            <Advertise />
            <New />
            <Subscribe />
            <Prodect />
            <Footer5 />
        </>
    )
}

export default Main
